import React, { useEffect } from "react";
import { TextField, Box } from "@material-ui/core";
import { useIntl } from "react-intl";
import { makeStyles } from "@material-ui/styles";

import ButtonWithLoader from "../../../../../components/ui/Buttons/ButtonWithLoader";
import { useCompany } from "./useCompany";
import { IUser } from "../../../../../interfaces/users";

const innerStyles = makeStyles(theme => ({
  title: {
    fontSize: 16,
    marginBottom: 16,
  },
}));

export function UserCompanyField({
  disabled,
  currentUser,
  classes,
  onSuccess,
}: {
  disabled: boolean;
  currentUser: IUser;
  classes: any;
  onSuccess?: () => void;
}) {
  const innerClasses = innerStyles();
  const intl = useIntl();
  const { create, edit, loading, success } = useCompany();
  const [companyName, setCompanyName] = React.useState<string>("");

  useEffect(() => {
    if (currentUser?.company) {
      setCompanyName(currentUser.company.short_name);
    }
  }, [currentUser]);

  useEffect(() => {
    if (success) {
      onSuccess?.();
    }
  }, [success]);

  const handleSubmit = () => {
    if (currentUser?.company) {
      edit({ short_name: companyName, company_id: currentUser.company.id });
    } else {
      create({ short_name: companyName, userId: currentUser.id });
    }
  };

  return (
    <>
      <div className="kt-form">
        <Box className={classes.paramContainer} border={1} borderColor={currentUser?.company ? "#6775c4" : "#eeeeee"} borderRadius={5}>
          <div className={innerClasses.title}>{currentUser.company ? "Редактирование компании" : "Создание компании"}</div>
          <TextField
            type="text"
            label={intl.formatMessage({
              id: "COMPANY.FORM.NAME",
            })}
            margin="normal"
            value={companyName}
            onChange={e => setCompanyName(e.target.value)}
            variant="outlined"
            disabled={disabled}
          />
          {!disabled && (
            <div className={classes.buttonContainer}>
              <ButtonWithLoader onPress={handleSubmit} loading={loading} disabled={loading}>
                {currentUser?.company ? "Сохранить" : "Создать"}
              </ButtonWithLoader>
            </div>
          )}
        </Box>
      </div>
    </>
  );
}
